var _a, _b, _c;
import { TABLET_WIDTH } from "@codex/utils/constants";
var banner = require('../../assets/images/header.jpg');
var bannerMobile = require('../../assets/images/header-mobile.png');
var styles = (_a = {
        imgResponsive: {
            width: '100%'
        },
        banner: {
            backgroundImage: "url(" + banner + ")",
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'relative',
            height: 331,
            objectFit: 'contain',
        },
        bannerContent: {
            textAlign: 'center',
            // position: 'absolute',
            // top: '50%',
            // left: '50%',
            // width:'70%',
            // transform: 'translate(-50%, -50%)',
            color: 'white',
        },
        bannerHeadText: {
            height: 36,
            textShadow: '0 0 13px #3d566e',
            direction: 'rtl',
            marginBottom: 20,
            fontSize: 50,
            fontWeight: 800,
            fontFamily: 'Assistant Extra Bold',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 0.72,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#ffffff',
        },
        bannerSubText: {
            // width: '100%',
            height: 36,
            textShadow: '0 0 13px #3d566e',
            direction: 'rtl',
            fontFamily: 'Assistant Semi Bold',
            fontSize: 30,
            fontWeight: 600,
            marginBottom: 51,
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.2,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#ffffff',
        },
        headerButton: (_b = {
                width: 312,
                height: 50,
                borderRadius: 25,
                backgroundColor: '#f2648b',
                borderColor: 'transparent'
            },
            _b['& span'] = {
                width: 168,
                height: 26,
                fontSize: 20,
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#ffffff',
            },
            _b['&:hover'] = {
                backgroundColor: '#f2648b',
            },
            _b['&:focus'] = {
                backgroundColor: '#f2648b',
            },
            _b),
        groups: {
            display: 'flex',
            flexDirection: 'row-reverse',
            height: 470,
        }
    },
    _a["@media screen and (max-width: " + TABLET_WIDTH + "px)"] = {
        banner: {
            backgroundImage: "url(" + bannerMobile + ")",
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'relative',
            height: 240,
            objectFit: 'contain',
        },
        bannerHeadText: {
            width: 'auto',
            height: 74,
            textShadow: '0 0 13px #3d566e',
            fontFamily: 'Assistant Extra Bold',
            marginBottom: 11,
            fontSize: 34,
            fontWeight: 800,
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.12,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#ffffff',
        },
        bannerSubText: {
            width: 'auto',
            textShadow: '0 0 13px #3d566e',
            fontFamily: 'Assistant Semi Bold',
            marginBottom: 15,
            fontSize: 16,
            fontWeight: 600,
            fontStyle: 'normal',
            fontStretch: 'normal',
            // lineHeight: 1.38,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#ffffff',
        },
        headerButton: (_c = {
                width: 219,
                height: 43,
                borderRadius: 25.4,
                backgroundColor: '#f2648b'
            },
            _c['& span'] = {
                width: 90,
                height: 21,
                fontFamily: 'Assistant',
                fontSize: 16,
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#ffffff',
            },
            _c['&:hover'] = {
                backgroundColor: '#f2648b',
            },
            _c['&:focus'] = {
                backgroundColor: '#f2648b',
            },
            _c),
        groups: {
            height: 333,
            padding: '30px 18px',
            marginBottom: 30,
        },
    },
    _a);
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/styles.ts
// module id = 1366
// module chunks = 0